export default {
  products: 'Products',
  search: 'Search',
  accountArea: 'Account Area',
  whyUs: 'Why Us',
  services: 'Services',
  company: 'Company',
  news: 'News',
  resources: 'Resources',
  contacts: 'Contacts',
  shop: 'Shop',
  privacy: 'Privacy Policy',
  cookie: 'Cookie Policy',
  copyright: 'Copyright',
  conditions: 'Conditions of Use',
  language: 'Change Language',
  comeFarePer: 'How to',
}
